$(document).ready(function () {
	/*Scroll top*/
	var scrollTop = $(".scrollTop");
	$(window).scroll(function () {
		var topPos = $(this).scrollTop();
		if (topPos > 0) {
			$(scrollTop).css("opacity", "1");
		} else {
			$(scrollTop).css("opacity", "0");
		}
	});
	$(scrollTop).click(function () {
		$('html, body').animate({
			scrollTop: 0
		}, 600);
		return false;
	});
	/*Menu dropdown*/
	var ico = $('<i class="fa fa-angle-down menudrop"></i>');
	$('.menu-link li:has(.submenu) > a').append(ico);
	$('.menudrop').on('click', function (e) {
		$(this).parent().parent().addClass('no-hover');

		$('.menu-link ul li').not($(this).parent().parent()).find('.submenu').stop(true, true).delay(200).fadeOut(500);
		$('.menu-link ul li').not($(this).parent().parent()).removeClass('open');
		$('.menu-link ul li a .menudrop').not($(this)).removeClass('openedmenu');
		$('.menu-link ul li a .menudrop').not($(this)).addClass('closemenu');

		e.preventDefault();
		if ($(this).hasClass('openedmenu')) {
			$(this).parent().parent().find('.submenu').stop(true, true).delay(200).fadeOut(500);
			$(this).removeClass('openedmenu');
			$(this).addClass('closemenu');

		} else {
			$(this).parent().parent().find('.submenu').stop(true, true).delay(200).fadeIn(500);
			$(this).removeClass('closemenu');
			$(this).addClass('openedmenu');
		}
	});


	if ($(window).width() >= 1120) {
		$(".menu-link nav > ul > li.has-sub").hover(
			function () {
				$('body').addClass("menuoverlay");
				$(window).trigger('resize');
			},
			function () {
				$('body').removeClass("menuoverlay");
			}
		);
	}

	/*-----BURGER MENU-----*/
	$(".togglebtn, .overlay").click(function () {
		$(".togglebtn, .overlay, .menu-link").toggleClass("active");
		if ($(".overlay").hasClass("active")) {
			$(".overlay").fadeIn();
			$('html').addClass('menuhidden');
		} else {
			$(".overlay").fadeOut();
			$('html').removeClass('menuhidden');
		}
	});

	/*-----FIXED HEADER-----*/

	$(window).scroll(function () {
		if (($(window).scrollTop() > 100) && ($(window).width() >= 319)) {
			if (!$('body').hasClass('fixed-header')) {
				$('body').css('padding-top', $('.mainheader').outerHeight());
			}
			$('body').addClass('fixed-header');
		} else {
			$('body').removeClass('fixed-header');
			$('body').css('padding-top', '');
		}
	});


	// Footer Toggle
	 $(".navbar-column .ft-head").click (function(){
        if ($(window).width() < 992) {
            let $this = $(this);
            
            $this.toggleClass('showhide');

            let $wrapper = $this.closest('.navbar-column');
            let $heads = $wrapper.find('.ft-head');

            $heads.not($this).removeClass('showhide');
            $heads.not('.showhide').next().stop().slideUp(300);
            $heads.filter('.showhide').next().stop().slideDown(300);
        }
    }); 


	// Pree header Google review

	$('.head-slide').slick({
		arrows: true,
		dots: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		horizontal: true,
		infinite: true,
		autoplay: true,
		fade: true,
		pauseOnHover: false,
		autoplaySpeed: 5000,
	});


	
	//   Keyfactor
	$(".keyfactor-hm .keyfactor-grid").slick({
			arrows: false,
			dots: false,
			slidesToShow: 5,
			slidesToScroll: 1,
			horizontal: true,
			infinite: true,
			autoplay: true,
			pauseOnHover: false,
			autoplaySpeed: 3000,
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 4,
					}
				},
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 3,
					}
				},
				{
					breakpoint: 501,
					settings: {
						slidesToShow: 2,
					}
				},
				{
					breakpoint: 361,
					settings: {
						slidesToShow: 1,
					}
				}
			]
		});

	// Fancybox
	$('[data-fancybox]').fancybox({
		touch: false,
		smallBtn: true
	});

});


